import NavigationScrollHandler from '../utils/_navigation-scroll'
import { forEach } from 'lodash'

export default function Navigation () {
  const MAIN_HEADER = document.getElementById('main_header')
  if (MAIN_HEADER) {
    const TRIGGER = MAIN_HEADER.querySelector('.navigation-toggle')
    const OVERLAY = document.querySelector('.main-header__overlay')
    const navigationClass = new NavigationClass(MAIN_HEADER, TRIGGER, OVERLAY)
    navigationClass.init()
  }
}

class NavigationClass {
  constructor (HEADER, TRIGGER, OVERLAY) {
    this.HEADER = HEADER
    this.TRIGGER = TRIGGER
    this.OVERLAY = OVERLAY
    this.MENU_ITEMS = this.HEADER.querySelectorAll('.menu-item')
    this.BACK_BUTTONS = this.HEADER.querySelectorAll('.back-to-overview')

    this.canToggle = true

    new NavigationScrollHandler({
      headerElement: this.HEADER,
      scrollDistance: 80,
      onEnter: () => {
        !this.HEADER.classList.contains('main-header--scrolled') && this.HEADER.classList.add('main-header--scrolled')
      },
      onExit: () => {
        this.HEADER.classList.contains('main-header--scrolled') && this.HEADER.classList.remove('main-header--scrolled')
      }
    })
  }

  init () {
    // Open
    this.TRIGGER && this.TRIGGER.addEventListener('click', () => this.toggleNav())
    // Close
    this.OVERLAY && this.OVERLAY.addEventListener('click', () => this.closeNav())
    document.addEventListener('keydown', (e) => e.key === 'Escape' && this.closeNav())
    forEach(this.MENU_ITEMS, (item) => item.addEventListener('click', (e) => this.handleMenuItemClick(e)))
  }

  toggleNav () {
    if (this.canToggle) {
      this.HEADER.classList.toggle('open')
      this.TRIGGER.classList.toggle('open')
      this.OVERLAY.classList.toggle('show')
      this.resetToggleable()
    }
  }

  closeNav () {
    this.HEADER.classList.remove('open')
    this.TRIGGER.classList.remove('open')
    this.OVERLAY.classList.remove('show')
  }

  resetToggleable () {
    this.canToggle = false
    setTimeout(() => { this.canToggle = true }, 500)
  }

  handleMenuItemClick (e) {
    if (window.innerWidth < 1160) {
      const parent = e.target.parentNode
      const subMenu = parent.querySelector('.sub-menu')

      if (subMenu) {
        e.preventDefault()
        this.addBackButton(subMenu)
        this.HEADER.classList.add('sub-menu-open')
        subMenu.classList.add('show')
      }
    }
  }

  addBackButton (subMenu) {
    const backButton = document.createElement('li')
    backButton.classList.add('menu-item', 'back-to-overview')
    backButton.innerHTML = '<a>Tilbage</a>'
    subMenu.append(backButton)

    backButton.addEventListener('click', () => this.handleBackToOverviewButtonClick())
  }

  removeBackButton () {
    const backButton = document.querySelector('.back-to-overview')
    if (backButton) {
      backButton.remove()
    }
  }

  handleBackToOverviewButtonClick () {
    const activeSubMenu = document.querySelector('.sub-menu.show')
    if (activeSubMenu) {
      document.querySelector('.sub-menu.show').classList.remove('show')
      this.HEADER.classList.remove('sub-menu-open')
    }
    this.removeBackButton()
  }
}